import React from 'react';
import {concatenate} from "services/string";
import {Menu} from "@headlessui/react";
import {Icon} from "../../types/Icon";
import Spinner from "../Spinner";

// Helpers ----

function getButtonClasses(active?: boolean, disabled?: boolean): string {
  return concatenate(
    (!!active) && (!disabled) ? 'bg-gray-100 text-gray-900' : null,
    (!!disabled) ? 'text-gray-400 pointer-events-none' : 'text-gray-700',
    'group flex items-center w-full px-4 py-2 text-sm font-normal'
  )
}

function getIconClasses(disabled?: boolean): string {
  return concatenate(
    (!!disabled) ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-500',
    'mr-3 h-5 w-5'
  )
}

// Component ----

export type DropdownItemProps = {
  name: string
  icon?: Icon
  onClick?: () => any
  url?: string
  download?: boolean
  disabled?: boolean
  isLoading?: boolean
}

function DropdownItem({name, icon: Icon, onClick, url, download, disabled, isLoading}: DropdownItemProps) {

  const renderItemChildren = (disabled?: boolean) => {
    return (
      <>
        {!!isLoading &&
          <Spinner size={Spinner.sizes.X_SMALL} color={Spinner.colors.DARK}/>
        }

        {!isLoading && !!Icon &&
          <Icon className={getIconClasses(disabled)} aria-hidden="true"/>
        }

        {name}
      </>
    )
  }

  const handleClick = (closeMenu: Function, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    if(onClick) onClick()
    closeMenu()
  }

  if (!!onClick) {
    return (
      <Menu.Item>
        {({active, close}) => (
          <button onClick={(event) => handleClick(close, event)} disabled={disabled} className={getButtonClasses(active, disabled)}>
            {renderItemChildren(disabled)}
          </button>
        )}
      </Menu.Item>
    )
  }

  return (
    <Menu.Item>
      {({active}) => (
        <a href={url || '#'} download={download} className={getButtonClasses(active, disabled)}>
          {renderItemChildren(disabled)}
        </a>
      )}
    </Menu.Item>
  )
}

export default DropdownItem;